var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 17.1666C2.87508 17.1666 2.48272 17.0035 2.15633 16.6771C1.82994 16.3507 1.66675 15.9583 1.66675 15.5V5.49998C1.66675 5.04165 1.82994 4.64929 2.15633 4.3229C2.48272 3.99651 2.87508 3.83331 3.33341 3.83331H16.6667C17.1251 3.83331 17.5174 3.99651 17.8438 4.3229C18.1702 4.64929 18.3334 5.04165 18.3334 5.49998V15.5C18.3334 15.9583 18.1702 16.3507 17.8438 16.6771C17.5174 17.0035 17.1251 17.1666 16.6667 17.1666H3.33341ZM10.0001 11.3333L16.6667 7.16665V5.49998L10.0001 9.66665L3.33341 5.49998V7.16665L10.0001 11.3333Z",
    fill: "#26262C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.e8bccc959bdeacda09e360ad050e15ae.svg";
export { ForwardRef as ReactComponent };